module.exports = __webpack_public_path__ + "static/media/t-shirt.46eeebf1.png";